class SafeJSON {
  static parse<T>(obj: string | null | undefined, def: T): T {
    try {
      return JSON.parse(obj || '')
    } catch (err) {
      return def
    }
  }
}

export default SafeJSON
